import { useBrokerDetailsStore } from '../../state/brokerDetailsStore';
import { handleAdminWarning } from '../../../../common/SharedFunctions';
import type dxValidationGroup from 'devextreme/ui/validation_group';

type ValidationGroupRef = React.RefObject<{
    instance: dxValidationGroup;
} | null>;

interface ValidationResult {
    isValid: boolean;
}

export interface ValidationUIState {
    showCompanyPanel: boolean;
    showBackgroundCheckDate: boolean;
    vgRef: ValidationGroupRef;
}

const _showValidationError = () => {
    handleAdminWarning('Please fill in all required fields.');
};

export const useBrokerAccountSetupValidation = () => {
    const validate = (uiState: ValidationUIState): ValidationResult => {
        //1. Validation Group
        const formValidation = uiState.vgRef.current?.instance?.validate();
        if (!formValidation?.isValid) {
            return { isValid: false };
        }

        const brokerDetailsStore = useBrokerDetailsStore.getState();

        // Always required
        if (!brokerDetailsStore.firstName || !brokerDetailsStore.lastName) {
            _showValidationError();
            return { isValid: false };
        }

        // Broker mode required fields
        if (brokerDetailsStore.isBroker) {
            if (
                !brokerDetailsStore.businessAddress.street1 ||
                !brokerDetailsStore.businessAddress.city ||
                !brokerDetailsStore.businessAddress.state ||
                !brokerDetailsStore.businessAddress.zipCode ||
                !brokerDetailsStore.phoneNumberA ||
                !brokerDetailsStore.email ||
                !brokerDetailsStore.eSignAgreement
            ) {
                _showValidationError();
                return { isValid: false };
            }
        }

        // Admin mode required fields
        if (brokerDetailsStore.isAdmin) {
            if (!brokerDetailsStore.email) {
                _showValidationError();
                return { isValid: false };
            }
            if (!brokerDetailsStore.iccaTemplateId || !brokerDetailsStore.pointOfContactId) {
                _showValidationError();
                return { isValid: false };
            }
        }

        // Company panel required fields
        if (uiState.showCompanyPanel) {
            if (!brokerDetailsStore.businessName || !brokerDetailsStore.businessState || !brokerDetailsStore.titleSelect) {
                _showValidationError();
                return { isValid: false };
            }
        }

        // Background check date
        if (uiState.showBackgroundCheckDate && !brokerDetailsStore.backgroundCheckDate) {
            _showValidationError();
            return { isValid: false };
        }

        return { isValid: true };
    };

    return { validate };
};
